


















































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { DetailItem } from "@/store/call/statistic/types";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import CallDetailFilter from "@/components/Call/CallDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {CallDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class CallDetail extends BaseItemsPage<DetailItem> {

  @Getter("callStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "country",
      "content",
      "status",
      "duration",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
